import {
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  RESET_ERROR_STATE,
  RESET_FORM_DATA,
  PERIMETERX_ENABLED,
} from '../actions/constants'

const initialState = {
  isLoginSuccess: false,
  isLoginError: false,
  isPerimeterXEnabled: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER_REQUEST:
      return { ...state, isLoading: true }
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoginSuccess: action.isLoginSuccess,
        ...action.response,
      }
    case LOGIN_USER_ERROR:
      return {
        ...state,
        ...action.response,
        isLoginError: true,
        isPerimeterXEnabled: false,
      }
    case RESET_ERROR_STATE:
      return {
        ...state,
        isLoginError: false,
        isLoginSuccess: false,
        isPerimeterXEnabled: false,
      }
    case RESET_FORM_DATA:
      return {
        ...state,
        formData: {},
      }
    case PERIMETERX_ENABLED:
      return {
        ...state,
        isPerimeterXEnabled: true,
        ...action.response,
      }
    default:
      return state
  }
}
